import React from "react";

export interface LookupTableInputProps {
  value: string;
  onOpen: () => void;
  className?: string;
  onBlur?: () => void;
  style?: React.CSSProperties;
}

export const LookupTableInput: React.FC<LookupTableInputProps> = ({ value, onOpen, className = "", style = {}, onBlur }) => {
  return (
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 4,
        width: "100%",
        minHeight: 32,
        height:32,
        backgroundColor: "white",
        border: "1px solid #cfcfcf",
        borderRadius: 4,
        boxSizing: "border-box",
        cursor: "pointer",
        ...style,
      }}
      onMouseDown={(e) => {
        e.preventDefault();
        onOpen();
      }}
      title={value}
      onBlur={()=> onBlur?.()}
    >
      {/* Left: table icon */}
      <img src="gif/lookup.gif" alt="Table" onMouseDown={(e) => e.preventDefault()} />

      {/* Value text */}
      <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{value}</div>

      {/* Right: dropdown caret */}
      <div style={{
            width:"16px", display: "flex", alignItems: "center", justifyContent: "center",
            backgroundRepeat: "no-repeat",
            backgroundColor: "#ebebeb",
            border: "1px solid #bbb",
            backgroundPosition: "center center",
            float: "right",
            height: "100%",
            padding: "0",
            margin: "0",
      }}><img src="gif/sortedasc.gif" alt="Dropdown" onMouseDown={(e) => e.preventDefault()} /></div>
    </div>
  );
};
